import { useState, useRef, useEffect } from "react";
import { AiOutlineMedium } from "react-icons/ai";
import { BiLogoTelegram } from "react-icons/bi";
import { RiArrowDownSLine, RiGlobalLine, RiTwitterXLine } from "react-icons/ri";

export default function Footer() {
  const [isLanguageOpen, setIsLanguageOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [{ code: "EN", label: "English" }];
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsLanguageOpen(false);
      }
    };

    if (isLanguageOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLanguageOpen]);

  const handleLanguageSelect = (code: string) => {
    setSelectedLanguage(code);
    setIsLanguageOpen(false);
    // 여기에 언어 변경 로직을 추가할 수 있습니다
  };

  return (
    <footer className="relative z-10 w-full bg-white text-black">
      <div className="container mx-auto px-4 py-20">
        <div className="flex flex-col md:flex-col lg:flex-row gap-8 mb-8">
          <div className="flex flex-col md:col-span-1 lg:flex-1">
            <div className="flex flex-row gap-4 mb-8 text-[24px]">
              <a
                href="https://x.com/protocol_switch"
                className="text-black hover:opacity-80 transition-opacity"
              >
                <RiTwitterXLine />
              </a>
              <a
                href="https://t.me/+VuAllEu7z11jMzk1"
                className="text-black hover:opacity-80 transition-opacity"
              >
                <BiLogoTelegram />
              </a>
              <a
                href="https://medium.com/@switch_protocol"
                className="text-black hover:opacity-80 transition-opacity"
              >
                <AiOutlineMedium />
              </a>
            </div>
            <p className="text-black text-sm">
              © 2025 SWITCH PROTOCOL. All rights reserved.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:flex lg:flex-row gap-8 md:gap-8 lg:flex-1">
            <div className="flex flex-1 flex-col">
              <div className="flex flex-col gap-3">
                <a
                  href="https://switch-protocol.gitbook.io/switch-protocol/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  WhitePaper
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("section3");
                  }}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  Ecosystem
                </a>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection("section8");
                  }}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  Community
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  GitHub
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  Disclaimer
                </a>
              </div>
            </div>

            <div className="flex flex-1 flex-col">
              <div className="flex flex-col gap-3">
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  Blog
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  Event
                </a>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  className="text-black hover:opacity-80 transition-opacity text-[16px]"
                >
                  Contact us
                </a>
              </div>
            </div>

            <div
              className="flex flex-1 flex-col relative w-fit"
              ref={dropdownRef}
            >
              <button
                onClick={() => setIsLanguageOpen(!isLanguageOpen)}
                className="flex items-center gap-2 text-black hover:opacity-80 transition-opacity cursor-pointer w-fit"
              >
                <RiGlobalLine className="text-xl" />
                <span className="text-[16px]">{selectedLanguage}</span>

                <RiArrowDownSLine
                  className={`text-sm transition-transform duration-200 ${
                    isLanguageOpen ? "rotate-180" : ""
                  }`}
                />
              </button>
              {isLanguageOpen && (
                <div className="absolute top-8 left-0 bg-white border border-gray-200 rounded-lg shadow-lg min-w-[120px] z-50">
                  {languages.map((lang) => (
                    <button
                      key={lang.code}
                      onClick={() => handleLanguageSelect(lang.code)}
                      className={`w-full text-left px-4 py-2 text-[16px] hover:bg-gray-100 transition-colors first:rounded-t-lg last:rounded-b-lg ${
                        selectedLanguage === lang.code
                          ? "bg-gray-50 font-medium"
                          : ""
                      }`}
                    >
                      {lang.label}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
